import React, { useEffect, useRef } from "react";
import { ADSENSE_ID } from "../lib/ads";

/**
 * AdSlot — renders a real AdSense ad unit if REACT_APP_ADSENSE_ID is set,
 * otherwise renders a subtle placeholder so the layout doesn't collapse.
 */
export const AdSlot = ({ slot = "auto", format = "auto", size = "banner", className = "" }) => {
  const ref = useRef(null);
  const enabled = Boolean(ADSENSE_ID);

  useEffect(() => {
    if (!enabled) return;
    // Lazy-load the AdSense script once
    if (!document.querySelector("script[data-adsense]")) {
      const s = document.createElement("script");
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_ID}`;
      s.async = true;
      s.crossOrigin = "anonymous";
      s.setAttribute("data-adsense", "true");
      document.head.appendChild(s);
    }
    try {
      // eslint-disable-next-line no-unused-expressions
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, [enabled]);

  const dims = size === "large" ? "min-h-[250px]" : size === "square" ? "min-h-[250px]" : "min-h-[90px]";

  if (!enabled) {
    return (
      <div
        data-testid={`ad-slot-placeholder-${slot}`}
        className={`surface rounded-lg flex items-center justify-center text-[color:var(--text-3)] font-mono text-[10px] uppercase tracking-[0.3em] ${dims} ${className}`}
      >
        Advertisement
      </div>
    );
  }

  return (
    <ins
      ref={ref}
      data-testid={`ad-slot-${slot}`}
      className={`adsbygoogle block ${dims} ${className}`}
      style={{ display: "block" }}
      data-ad-client={ADSENSE_ID}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
};

export default AdSlot;
